module.exports = __webpack_public_path__ + "img/audio.fc4c47fa.svg";